<h3 class="title configurator-title">{{ 'workbench.summary.title' | translate }}</h3>

<ng-casto-loader *ngIf="isLoading"></ng-casto-loader>

<ng-container *ngIf="!isLoading">
  <div class="summary-container shadow mt-4" *ngFor="let categoryName of getCategories()">
    <h4 class="title summary-title">{{ categoryName }}</h4>

    <div class="summary-infos">
      <div class="info info-workbench" *ngFor="let ean of getProducts(categoryName)">
        <!-- {{ ean[getPropertyNameLocalize('name')] }} : {{ ean.quantity }}  Retrait pour afficher uniquement les infos additionnelles.-->
        <div class="sub-group">
          <div class="sub-desc" [innerHTML]="ean.additionalInfo"></div>
          <p class="sub-price">{{ ean.pv * ean.quantity | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</p>
        </div>
      </div>
    </div>
  </div>

<!-- Si isOnlySplashback => Totaux filtrés -->
<div *ngIf="isOnlySplashback" class="summary-container prices-container shadow mt-4">
  <div class="price-row">
    <h4 class="title summary-title">{{ 'workbench.summary.total-without-vat' | translate }} :</h4>
    <p class="info">{{ getTotalHT() | number: '1.1-2' }} €</p>
  </div>
  <div class="price-row">
    <h4 class="title summary-title">
      {{ 'workbench.summary.vat-total' | translate }} ({{ configuration.resume.percentTVA }} %) :
    </h4>
    <p class="info">{{ getTotalTVA() | number: '1.1-2' }} €</p>
  </div>
  <div class="price-row principale">
    <h4 class="title summary-title">{{ 'workbench.summary.total-with-vat' | translate }} :</h4>
    <p class="info">{{ getTotalTTC() | number: '1.1-2' }} €</p>
  </div>
</div>

<!-- Sinon => Totaux normaux (non filtrés, comme avant) -->
<div *ngIf="!isOnlySplashback" class="summary-container prices-container shadow mt-4">
  <div class="price-row">
    <h4 class="title summary-title">{{ 'workbench.summary.total-without-vat' | translate }} :</h4>
    <p class="info">{{ configuration.resume.totalHT | number: '1.1-2' }} €</p>
  </div>
  <div class="price-row">
    <h4 class="title summary-title">
      {{ 'workbench.summary.vat-total' | translate }} ({{ configuration.resume.percentTVA }} %) :
    </h4>
    <p class="info">{{ configuration.resume.totalTVA | number: '1.1-2' }} €</p>
  </div>
  <div class="price-row principale">
    <h4 class="title summary-title">{{ 'workbench.summary.total-with-vat' | translate }} :</h4>
    <p class="info">{{ configuration.resume.totalPV | number: '1.1-2' }} €</p>
  </div>
</div>


</ng-container>
